import { baseApi } from "@/shared/api";
import type { Course, CourseUser } from "../model/types";

export interface SSRHeaders {
  host?: string;
  cookie?: string;
  [key: string]: string | undefined;
}

export const courseApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCourse: builder.query<Course, SSRHeaders | void>({
      query: (headers) => ({
        url: "/courses/get",
        headers: headers || undefined,
      }),
      providesTags: ["Course"],
    }),
    getInlineCourse: builder.query<
      { course: Course; simulator: number },
      string
    >({
      query: (courseSlug: string) => ({
        url: `/courses/inline_get/${courseSlug}`,
      }),
      providesTags: ["Course"],
    }),
    getCourseUser: builder.query<CourseUser, SSRHeaders | void>({
      query: (headers) => ({
        url: "/courses/user",
        headers: headers || undefined,
      }),
      providesTags: ["CourseUser"],
    }),
    setCurrentLesson: builder.mutation<void, { lesson: number }>({
      query: (body) => ({
        url: "/courses/current_lesson/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["CourseUser"],
    }),

    initiateCoursePayment: builder.mutation<
      {
        confirmation_url: string;
        payment_id: string;
        purchase_id: number;
      },
      {
        selected_tariff_id: string;
        name: string;
        email: string;
        promocode?: string;
      }
    >({
      query: (body) => ({
        url: "/courses/payment/initiate/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Course", "CourseUser"],
    }),

    getCoursePaymentStatus: builder.query<{ status: 0 | 1 | 2 }, void>({
      query: () => ({
        url: "/courses/payment/status/",
      }),
    }),

    resetCoursePayment: builder.mutation<{ ok: boolean }, void>({
      query: () => ({
        url: "/courses/payment/reset/",
        method: "POST",
      }),
      invalidatesTags: ["CourseUser"],
    }),
  }),
});

export const {
  useGetCourseQuery,
  useGetCourseUserQuery,
  useSetCurrentLessonMutation,
  useGetInlineCourseQuery,
  useInitiateCoursePaymentMutation,
  useGetCoursePaymentStatusQuery,
  useResetCoursePaymentMutation,
} = courseApi;
